import type React from 'react'

import css from './styles.module.css'

export const InfoBannerContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={css.info_banner_container}>{children}</div>
